import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Http, Routes } from "../../../utils/constants";
import { useGlobalState } from "../../../contexts/GlobalContext";
import { fetchUserInfoProxy } from "../../../utils/helpers/api";
import {
  fetchResignUser,
  fetchUpdateUserMetaData,
  getOrderIds,
  handleSearchCustomerInfo,
  updateContactSF,
  deleteAllClipping,
} from "../../../utils/helpers/api";
import { AxiosResponse } from "axios";
import { appConfig } from "../../../utils/configs";

const WithdRawalConfirm: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { setStateValue, globalState } = useGlobalState();
  const { reason } = location.state || "";
  const { user } = globalState;
  const handleEdit = () => {
    navigate(Routes.WITHDRAWAL, { state: { reason: reason ?? "" } });
  };

  useEffect(() => {
    document.title = "宣伝会議 : アカウント管理 | 退会確認";
  }, []);

  
  const handleActionUpdateSaleForce = async () => {
    try {
      const detail = await handleSearchCustomerInfo(
        user?.user_metadata.customUserId.toString(),
        user?.user_metadata.profile?.fullName?.lastName,
        user?.user_metadata.profile?.fullName?.firstName,
        user?.user_metadata.workPlaceInfo?.companyName,
        user?.email
      );
      const idContact = detail?.data?.ContactId ?? "";
      if (idContact) {
        await updateContactSF(idContact, { Delete__c: true });
      }
    } catch (error) {
      return error;
    }
  };

  const handleSubmit = async () => {
    setStateValue("loader", true);
    try {
      const timestamp = new Date().toISOString();
      const userMetadata = user?.user_metadata ?? {};
      const newsletter = userMetadata.newsletterSubscription ?? {};
      const update = userMetadata.newsletterSubscriptionUpdate ?? {};
      Object.keys(newsletter).forEach((key) => {
        if (newsletter[key]) {
          if (!update[key]) update[key] = {};
          update[key].off = timestamp;
        }
      });
      await fetchUpdateUserMetaData(user?.user_id, {
        ...userMetadata,
        newsletterSubscriptionUpdate: update,
      });
      const result = await fetchResignUser(
        user?.app_metadata?.ssoUserId ?? "",
        user.user_id,
        reason
      );
      await handleActionUpdateSaleForce();
      if (result?.status === Http.SUCCESS_CODE) {
        await deleteAllClipping();
        navigate(Routes.WITHDRAWALFINISH);
      }
    } catch (error) {
      if (!(error instanceof Error)) {
        const res = error as AxiosResponse;
        return error;
      }
    } finally {
      setStateValue("loader", false);
    }
  };

  return (
    <Box className="page__withdrawal">
      <div>
        <div className="header-tit">
          {t("features.withdrawal.confirm.title")}
        </div>
        <p className="mb12">{t("features.withdrawal.confirm.pleaseCheck")}</p>
        <p className="mb0">{t("features.withdrawal.confirm.caution")}</p>
        <div className="text-danger">
          {t("features.withdrawal.contestWarningPart0")}
          <br />
          {t("features.withdrawal.contestWarningPart1")}
          <br />
          {t("features.withdrawal.contestWarningPart2")}
          <br />
          {t("features.withdrawal.contestWarningPart3")}
        </div>
        <hr />
        <div className="form-horizontal mt-3">
          <div className="form-group row">
            <label className="txt-loud mb5">
              {t("features.withdrawal.withdrawalReason")}
            </label>
            <div className="col-sm-12">{reason}</div>
          </div>
        </div>
        <hr />
        <div className="confirm-footer mt-4">
          <Button
            onClick={handleEdit}
            className="btn btn-default form-control btn-md"
          >
            {t("common.edit")}
          </Button>
          <Button
            onClick={handleSubmit}
            className="btn form-control btn-md"
          >
            {t("features.withdrawal.confirm.submit")}
          </Button>
        </div>
      </div>
    </Box>
  );
};

export default WithdRawalConfirm;
